import type Phaser from "phaser";

import { appendDispatchMessage } from "./radio-dispatch.js";
import { showDispatchToast } from "../game/clue-toast.js";

const ACCUSATION_NUDGE_SEC = 900;
const DISPATCH_NUDGE =
  "Dispatch: Hey, it's been a while - the District Attorney is getting impatient. Ready to make an accusation?";

let accusationNudgeFired = false;
let canFireNudge = true;

export function resetInvestigationNudges(): void {
  accusationNudgeFired = false;
  canFireNudge = true;
}

export function setInvestigationNudgesEnabled(enabled: boolean): void {
  canFireNudge = enabled;
}

export function onInvestigationTimerTick(
  elapsedSec: number,
  scene: Phaser.Scene | null,
  opts?: { caseResolved?: boolean; accusationPhase?: boolean }
): void {
  if (!canFireNudge || accusationNudgeFired) return;
  if (opts?.caseResolved || opts?.accusationPhase) return;
  if (elapsedSec < ACCUSATION_NUDGE_SEC) return;

  accusationNudgeFired = true;
  appendDispatchMessage(DISPATCH_NUDGE, elapsedSec);
  if (scene) showDispatchToast(scene, DISPATCH_NUDGE);
}
